import React, { useState, useEffect } from 'react';
import axios from 'axios';
const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(req => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = 'Bearer ' + token;
  return req;
});

const LANG_KEY = 'adminLang';
const STRINGS = {
 zh:{err:'\u4ec5\u7ba1\u7406\u5458\u53ef\u67e5\u770b',loading:'\u52a0\u8f7d\u4e2d...',title:'\u540e\u53f0\u7edf\u8ba1',subtitle:'\u4ec5\u7ba1\u7406\u5458\u53ef\u89c1',langLabel:'\u8bed\u8a00',verifyQueue:'\u7167\u7247\u5ba1\u6838\u961f\u5217',noPendingReview:'\u6682\u65e0\u5f85\u5ba1\u6838\u7533\u8bf7',approve:'\u901a\u8fc7',reject:'\u62d2\u7edd',totalVisits:'\u603b\u8bbf\u95ee',today:'\u4eca\u65e5',online:'\u5728\u7ebf',system:'\u7cfb\u7edf\u6570\u636e',users:'\u7528\u6237',friendPairs:'\u597d\u53cb\u5bf9',messages:'\u6d88\u606f',products:'\u5546\u54c1',orders:'\u8ba2\u5355',shops:'\u5e97\u94fa',topPages:'\u9875\u9762\u6392\u884c',times:'\u6b21',hourly:'\u65f6\u6bb5\u5206\u5e03 (24h)',userMgmt:'\u7528\u6237\u7ba1\u7406',searchPh:'\u641c\u7d22\u7528\u6237\u540d/\u6635\u79f0/\u56fd\u5bb6...',noMatch:'\u65e0\u5339\u914d\u7528\u6237',onlineNow:'\u5f53\u524d\u5728\u7ebf',feedback:'\u7528\u6237\u53cd\u9988',unread:'\u672a\u8bfb',read:'\u5df2\u8bfb',pendingPay:'\u5f85\u786e\u8ba4\u4ed8\u6b3e',noPendingOrders:'\u6682\u65e0\u5f85\u786e\u8ba4\u8ba2\u5355',alipay:'\u652f\u4ed8\u5b9d',wechat:'\u5fae\u4fe1',confirm:'\u786e\u8ba4',qrCode:'\u6536\u6b3e\u7801',notUploaded:'\u672a\u4e0a\u4f20',upload:'\u4e0a\u4f20',uploadOk:'\u4e0a\u4f20\u6210\u529f',uploadFail:'\u4e0a\u4f20\u5931\u8d25',orderNo:'\u5355\u53f7'},
 en:{err:'Admins only',loading:'Loading...',title:'Admin Dashboard',subtitle:'Administrators only',langLabel:'Language',verifyQueue:'Photo Review Queue',noPendingReview:'No pending requests',approve:'Approve',reject:'Reject',totalVisits:'Total visits',today:'Today',online:'Online',system:'System Data',users:'Users',friendPairs:'Friend pairs',messages:'Messages',products:'Products',orders:'Orders',shops:'Shops',topPages:'Page Ranking',times:'visits',hourly:'Hourly Distribution (24h)',userMgmt:'User Management',searchPh:'Search username / name / country...',noMatch:'No matching users',onlineNow:'Currently Online',feedback:'User Feedback',unread:'Unread',read:'Read',pendingPay:'Pending Payments',noPendingOrders:'No pending orders',alipay:'Alipay',wechat:'WeChat',confirm:'Confirm',qrCode:'Payment QR Codes',notUploaded:'Not uploaded',upload:'Upload',uploadOk:'Uploaded',uploadFail:'Upload failed',orderNo:'Order'},
 ja:{err:'\u7ba1\u7406\u8005\u306e\u307f\u5229\u7528\u3067\u304d\u307e\u3059',loading:'\u8aad\u307f\u8fbc\u307f\u4e2d...',title:'\u7ba1\u7406\u30c0\u30c3\u30b7\u30e5\u30dc\u30fc\u30c9',subtitle:'\u7ba1\u7406\u8005\u5c02\u7528',langLabel:'\u8a00\u8a9e',verifyQueue:'\u5199\u771f\u5be9\u67fb\u30ad\u30e5\u30fc',noPendingReview:'\u5be9\u67fb\u5f85\u3061\u306e\u7533\u8acb\u306f\u3042\u308a\u307e\u305b\u3093',approve:'\u627f\u8a8d',reject:'\u5374\u4e0b',totalVisits:'\u7dcf\u8a2a\u554f\u6570',today:'\u4eca\u65e5',online:'\u30aa\u30f3\u30e9\u30a4\u30f3',system:'\u30b7\u30b9\u30c6\u30e0\u30c7\u30fc\u30bf',users:'\u30e6\u30fc\u30b6\u30fc',friendPairs:'\u53cb\u9054\u30da\u30a2',messages:'\u30e1\u30c3\u30bb\u30fc\u30b8',products:'\u5546\u54c1',orders:'\u6ce8\u6587',shops:'\u30b7\u30e7\u30c3\u30d7',topPages:'\u30da\u30fc\u30b8\u30e9\u30f3\u30ad\u30f3\u30b0',times:'\u56de',hourly:'\u6642\u9593\u5e2f\u5206\u5e03 (24\u6642\u9593)',userMgmt:'\u30e6\u30fc\u30b6\u30fc\u7ba1\u7406',searchPh:'\u30e6\u30fc\u30b6\u30fc\u540d\u30fb\u8868\u793a\u540d\u30fb\u56fd\u3092\u691c\u7d22...',noMatch:'\u4e00\u81f4\u3059\u308b\u30e6\u30fc\u30b6\u30fc\u306f\u3044\u307e\u305b\u3093',onlineNow:'\u73fe\u5728\u30aa\u30f3\u30e9\u30a4\u30f3',feedback:'\u30e6\u30fc\u30b6\u30fc\u30d5\u30a3\u30fc\u30c9\u30d0\u30c3\u30af',unread:'\u672a\u8aad',read:'\u65e2\u8aad',pendingPay:'\u78ba\u8a8d\u5f85\u3061\u306e\u652f\u6255\u3044',noPendingOrders:'\u78ba\u8a8d\u5f85\u3061\u306e\u6ce8\u6587\u306f\u3042\u308a\u307e\u305b\u3093',alipay:'Alipay',wechat:'WeChat',confirm:'\u78ba\u8a8d',qrCode:'\u6c7a\u6e08QR\u30b3\u30fc\u30c9',notUploaded:'\u672a\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9',upload:'\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9',uploadOk:'\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u6210\u529f',uploadFail:'\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u5931\u6557',orderNo:'\u6ce8\u6587\u756a\u53f7'}
};
const LANGS=[{code:'zh',label:'\u4e2d\u6587'},{code:'en',label:'English'},{code:'ja',label:'\u65e5\u672c\u8a9e'}];
function getInitialLang() {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved && STRINGS[saved]) return saved;
    const nav = (navigator.language || '').toLowerCase();
    if (nav.startsWith('ja')) return 'ja';
    if (nav.startsWith('en')) return 'en';
  } catch (_) {}
  return 'zh';
}

export default function AdminPage() {
  const [lang, setLang] = useState(getInitialLang);
  const t = STRINGS[lang] || STRINGS.zh;
  const locale = lang === 'ja' ? 'ja-JP' : lang === 'en' ? 'en-US' : 'zh-CN';

  const switchLang = (code) => {
    setLang(code);
    try { localStorage.setItem(LANG_KEY, code); } catch (_) {}
  };

  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [err, setErr] = useState('');
  const [userSearch, setUserSearch] = useState('');
  const [logs, setLogs] = useState([]);
  const [logExpanded, setLogExpanded] = useState(false);
  const [verificationQueue, setVerificationQueue] = useState([]);
  const [safetyReports, setSafetyReports] = useState([]);
  const reportText = lang === 'en' ? {title:'Safety Reports',empty:'No open reports',resolve:'Resolve',dismiss:'Dismiss'} : lang === 'ja' ? {title:'安全レポート',empty:'未処理の報告はありません',resolve:'解決',dismiss:'却下'} : {title:'安全举报',empty:'暂无未处理举报',resolve:'处理完成',dismiss:'驳回'};

  useEffect(() => {
    api.get('/admin/stats').then(r => setStats(r.data)).catch(e => setErr(t.err));
    api.get('/admin/users').then(r => setUsers(r.data)).catch(() => {});
    api.get('/admin/contacts').then(r => setContacts(r.data)).catch(() => {});
    api.get('/admin/logs?n=100').then(r => setLogs(r.data.lines)).catch(() => {});
    api.get('/admin/verification').then(r => setVerificationQueue(r.data)).catch(() => {});
    api.get('/admin/safety-reports').then(r => setSafetyReports(r.data.filter(x=>x.status==='open'))).catch(() => {});
  }, []);

  const [pendingPayments, setPendingPayments] = useState([]);
  const [qrMsgs, setQrMsgs] = useState({});
  const [qrStatus, setQrStatus] = useState({});

  useEffect(() => {
    api.get('/admin/qr-status').then(r => setQrStatus(r.data)).catch(() => {});
  }, []);

  const uploadQr2 = async (type) => {
    const input = document.getElementById('qr-' + type);
    const file = input?.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('qr', file);
    try {
      const r = await api.post('/admin/upload-qr/' + type, fd);
      setQrMsgs(f => ({...f, [type]: ' ' + t.uploadOk}));
      api.get('/admin/qr-status').then(r => setQrStatus(r.data)).catch(() => {});
    } catch(e) { setQrMsgs(f => ({...f, [type]: ' ' + t.uploadFail})); }
  };

  useEffect(() => {
    api.get('/admin/pending-payments').then(r => setPendingPayments(r.data)).catch(() => {});
  }, []);

  const reviewVerification = async (id,status) => { await api.post('/admin/verification/'+id,{status}); setVerificationQueue(q=>q.filter(x=>x.id!==id)); };

  const reviewSafetyReport = async (id,status) => { await api.post('/admin/safety-reports/'+id,{status}); setSafetyReports(q=>q.filter(x=>x.id!==id)); };

  const confirmPayment = async (paymentId) => {
    await api.post('/admin/confirm-payment', { paymentId });
    api.get('/admin/pending-payments').then(r => setPendingPayments(r.data)).catch(() => {});
  };

  if (err) return <div className="page-center"><p style={{color:'var(--text-dim)'}}>{err}</p></div>;
  if (!stats) return <div className="page-center"><p style={{color:'var(--text-dim)'}}>{t.loading}</p></div>;

  const maxHourly = Math.max(...stats.hourly.map(h => h.count), 1);

  const filteredUsers = users.filter(u =>
    !userSearch || u.username.toLowerCase().includes(userSearch.toLowerCase()) ||
    u.display_name.toLowerCase().includes(userSearch.toLowerCase()) ||
    (u.country_code || '').toLowerCase().includes(userSearch.toLowerCase())
  );

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>{t.title}</h2>
        <p className="subtitle">{t.subtitle}</p>
        <div style={{marginTop:8,display:'flex',alignItems:'center',gap:8,justifyContent:'center'}}>
          <span style={{fontSize:'0.8rem',color:'var(--text-dim)'}}>{t.langLabel}:</span>
          {LANGS.map(l => (
            <button key={l.code} onClick={() => switchLang(l.code)} style={{
              padding:'4px 12px',borderRadius:16,fontSize:'0.8rem',cursor:'pointer',
              border: lang === l.code ? '1px solid #4f7cff' : '1px solid #333',
              background: lang === l.code ? 'rgba(79,124,255,0.15)' : 'transparent',
              color: lang === l.code ? '#4f7cff' : 'var(--text-dim)'
            }}>{l.label}</button>
          ))}
        </div>
        <div className="product-card" style={{maxWidth:800,margin:'16px auto',textAlign:'left'}}><h3>棣冩礉閿?{t.verifyQueue} ({verificationQueue.length})</h3>{verificationQueue.length===0?<p style={{color:'var(--text-dim)'}}>{t.noPendingReview}</p>:verificationQueue.map(v=><div key={v.id} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid var(--glass-border)'}}><img src={v.avatar_url} alt="" style={{width:44,height:44,borderRadius:'50%',objectFit:'cover'}} /><div style={{flex:1}}><strong>{v.display_name||v.username}</strong><div style={{fontSize:'.75rem',color:'var(--text-dim)'}}>{v.username} 璺?{new Date(v.submitted_at).toLocaleString(locale)}</div></div><button className="btn btn-primary" onClick={()=>reviewVerification(v.id,'approved')}>{t.approve}</button><button className="btn btn-secondary" onClick={()=>reviewVerification(v.id,'rejected')}>{t.reject}</button></div>)}</div>
      </div>

      <div className="product-card" style={{maxWidth:800,margin:'16px auto',textAlign:'left'}}><h3>🛡️ {reportText.title} ({safetyReports.length})</h3>{safetyReports.length===0?<p style={{color:'var(--text-dim)'}}>{reportText.empty}</p>:safetyReports.map(x=><div key={x.id} style={{padding:'10px 0',borderBottom:'1px solid var(--glass-border)'}}><div><strong>{x.reporter} → {x.target}</strong><span style={{marginLeft:8,color:'var(--text-dim)',fontSize:'.8rem'}}>{x.category}</span></div><div style={{fontSize:'.82rem',margin:'5px 0'}}>{x.details||'—'}</div><button className="btn btn-primary" onClick={()=>reviewSafetyReport(x.id,'resolved')} style={{marginRight:8,padding:'5px 10px'}}>{reportText.resolve}</button><button className="btn btn-secondary" onClick={()=>reviewSafetyReport(x.id,'dismissed')} style={{padding:'5px 10px'}}>{reportText.dismiss}</button></div>)}</div>

      <div className="discovery-stats" style={{marginBottom:24}}>
        <div className="stat-item"><div className="stat-number">{stats.visits.total}</div><div className="stat-label">{t.totalVisits}</div></div>
        <div className="stat-item"><div className="stat-number">{stats.visits.today}</div><div className="stat-label">{t.today}</div></div>
        <div className="stat-item"><div className="stat-number">{stats.online.count}</div><div className="stat-label">{t.online}</div></div>
      </div>

      <div className="product-card" style={{maxWidth:800,margin:'0 auto 16px',textAlign:'left'}}><h3>📈 转化漏斗</h3><div className="download-steps"><div>注册完成：{stats.funnel?.registerComplete || 0}</div><div>会员支付成功：{stats.funnel?.membershipPurchaseComplete || 0}</div><div>已记录事件：{stats.funnel?.trackedEvents || 0}</div></div></div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:20,maxWidth:800,margin:'0 auto'}}>
        <div className="product-card">
          <h3 style={{marginBottom:12}}>{t.system}</h3>
          <div className="download-steps">
            <div>{t.users}: {stats.system.users}</div>
            <div>{t.friendPairs}: {stats.system.friends}</div>
            <div>{t.messages}: {stats.system.messages}</div>
            <div>{t.products}: {stats.system.products}</div>
            <div>{t.orders}: {stats.system.orders}</div>
            <div>{t.shops}: {stats.system.shops}</div>
          </div>
        </div>

        <div className="product-card">
          <h3 style={{marginBottom:12}}>{t.topPages}</h3>
          <div className="download-steps">
            {stats.pages.map((p,i) => (
              <div key={p.page}>#{i+1} /{p.page}: {p.count}{t.times}</div>
            ))}
          </div>
        </div>
      </div>

      <div className="product-card" style={{maxWidth:800,margin:'20px auto 0'}}>
        <h3 style={{marginBottom:12}}>{t.hourly}</h3>
        <div style={{display:'flex',alignItems:'flex-end',gap:2,height:120,padding:'0 4px'}}>
          {Array.from({length:24}, (_,i) => {
            const h = stats.hourly.find(x => x.hour === i);
            const count = h?.count || 0;
            const pct = (count / maxHourly) * 100;
            return (
              <div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:2}}>
                <div style={{fontSize:'0.6rem',color:'var(--text-dim)',opacity:count>0?1:0.3}}>{count}</div>
                <div style={{
                  width:'100%',height:Math.max(4, pct),background:'linear-gradient(180deg,#4f7cff,#ff6b9d)',
                  borderRadius:'2px 2px 0 0',transition:'height 0.3s',minHeight:count?4:2,
                  opacity:count?1:0.2
                }} />
              </div>
            );
          })}
        </div>
        <div style={{display:'flex',justifyContent:'space-between',fontSize:'0.65rem',color:'var(--text-dim)',marginTop:4}}>
          <span>0:00</span><span>6:00</span><span>12:00</span><span>18:00</span><span>24:00</span>
        </div>
      </div>

      <div className="product-card" style={{maxWidth:800,margin:'20px auto 0'}}>
        <h3 style={{marginBottom:8}}>{t.userMgmt} ({users.length})</h3>
        <div style={{marginBottom:10}}>
          <input
            type="text"
            placeholder={t.searchPh}
            value={userSearch}
            onChange={e => setUserSearch(e.target.value)}
            style={{
              width:'100%',padding:'8px 12px',borderRadius:6,border:'1px solid #333',
              background:'#1a1a2e',color:'white',fontSize:'0.85rem',boxSizing:'border-box'
            }}
          />
        </div>
        <div style={{maxHeight:400,overflowY:'auto'}}>
          {filteredUsers.length === 0 ? (
            <p style={{color:'var(--text-dim)',fontSize:'0.85rem'}}>{t.noMatch}</p>
          ) : filteredUsers.map((u, idx) => (
            <div key={u.id} style={{
              display:'flex',justifyContent:'space-between',alignItems:'center',
              padding:'6px 0',borderBottom:'1px solid rgba(255,255,255,0.05)',
              fontSize:'0.85rem'
            }}>
              <div style={{display:'flex',alignItems:'center',gap:8,minWidth:0}}>
                <span style={{color:'var(--text-dim)',minWidth:24}}>#{idx+1}</span>
                <span style={{
                  display:'inline-flex',width:24,height:24,borderRadius:'50%',
                  background: u.avatar_url ? 'transparent' : 'linear-gradient(135deg,#4f7cff,#ff6b9d)',
                  fontSize:'0.7rem',alignItems:'center',justifyContent:'center',
                  color:'white',fontWeight:600,flexShrink:0
                }}>
                  {u.display_name ? u.display_name.charAt(0).toUpperCase() : '?'}
                </span>
                <div style={{minWidth:0}}>
                  <strong style={{color:'white',marginRight:6}}>{u.username}</strong>
                  {u.display_name !== u.username && (
                    <span style={{color:'var(--text-dim)',fontSize:'0.75rem'}}>({u.display_name})</span>
                  )}
                </div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                {u.country_code && <span style={{fontSize:'0.7rem',background:'rgba(79,124,255,0.15)',color:'#4f7cff',padding:'1px 6px',borderRadius:4}}>{u.country_code}</span>}
                <span style={{fontSize:'0.7rem',color:'var(--text-dim)'}}>
                  {new Date(u.created_at).toLocaleDateString(locale)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {stats.online.users.length > 0 && (
        <div className="product-card" style={{maxWidth:800,margin:'20px auto 0'}}>
          <h3 style={{marginBottom:8}}>{t.onlineNow}</h3>
          <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
            {stats.online.users.map(u => (
              <span key={u} className="meta-badge" style={{background:'rgba(74,222,128,0.15)',color:'#4ade80'}}>{u}</span>
            ))}
          </div>
        </div>
      )}

      {contacts.length > 0 && (
        <div className="product-card" style={{maxWidth:800,margin:'20px auto 0'}}>
          <h3 style={{marginBottom:12}}>{t.feedback} ({contacts.length})</h3>
          <div className="download-steps">
            {contacts.slice(0,10).map(c => (
              <div key={c.id} style={{padding:'8px 0',borderBottom:'1px solid var(--glass-border)'}}>
                <div style={{display:'flex',gap:8,alignItems:'center'}}>
                  <strong>{c.name}</strong>
                  <span style={{fontSize:'0.7rem',color:'var(--text-dim)'}}>{c.type} {new Date(c.created_at).toLocaleString(locale)}</span>
                  <span style={{fontSize:'0.7rem',background:c.status==='unread'?'rgba(239,68,68,0.15)':'rgba(74,222,128,0.15)',color:c.status==='unread'?'#ef4444':'#4ade80',padding:'2px 8px',borderRadius:4}}>{c.status==='unread'?t.unread:t.read}</span>
                </div>
                <div style={{fontSize:'0.85rem',marginTop:4}}>{c.message.substring(0,100)}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <h3 style={{marginTop:24,fontSize:'1rem'}}>{t.pendingPay}</h3>
      {pendingPayments.length === 0 ? (
        <p style={{color:'var(--text-dim)',fontSize:'0.85rem'}}>{t.noPendingOrders}</p>
      ) : pendingPayments.map(p => (
        <div key={p.id} style={{background:'#1a1a2e',borderRadius:8,padding:12,margin:'8px 0',border:'1px solid #2a2a3e'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <div style={{fontWeight:600}}>{p.username} - {p.method === 'alipay' ? t.alipay : t.wechat}</div>
              <div style={{fontSize:'0.85rem',color:'var(--text-dim)'}}>${p.amount} - {t.orderNo}: {p.transactionId}</div>
            </div>
            <button className="btn btn-primary" onClick={() => confirmPayment(p.id)} style={{padding:'6px 14px',fontSize:'0.85rem'}}>{t.confirm}</button>
          </div>
        </div>
      ))}

      <h3 style={{marginTop:24,fontSize:'1rem'}}>{t.qrCode}</h3>
      <div style={{display:'flex',gap:24,margin:'8px 0 24px',flexWrap:'wrap'}}>
        <div>
          <p style={{fontSize:'0.85rem',color:'var(--text-dim)',marginBottom:4}}>{t.alipay}</p>
          {qrStatus.alipay ? <img src={qrStatus.alipay} style={{width:120,height:120,borderRadius:8,objectFit:'contain',background:'#2a2a3e',display:'block',marginBottom:4}} /> : <div style={{width:120,height:120,borderRadius:8,background:'#2a2a3e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.75rem',color:'#555',marginBottom:4}}>{t.notUploaded}</div>}
          <input id="qr-alipay" type="file" accept="image/*" style={{fontSize:'0.8rem',width:120}} />
          <button className="btn btn-secondary" onClick={() => uploadQr2('alipay')} style={{padding:'4px 10px',fontSize:'0.8rem',marginTop:4}}>{t.upload}</button>
          {qrMsgs.alipay && <p style={{fontSize:'0.8rem',color:'#4ade80',marginTop:2}}>{qrMsgs.alipay}</p>}
        </div>
        <div>
          <p style={{fontSize:'0.85rem',color:'var(--text-dim)',marginBottom:4}}>{t.wechat}</p>
          {qrStatus.wechat ? <img src={qrStatus.wechat} style={{width:120,height:120,borderRadius:8,objectFit:'contain',background:'#2a2a3e',display:'block',marginBottom:4}} /> : <div style={{width:120,height:120,borderRadius:8,background:'#2a2a3e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.75rem',color:'#555',marginBottom:4}}>{t.notUploaded}</div>}
          <input id="qr-wechat" type="file" accept="image/*" style={{fontSize:'0.8rem',width:120}} />
          <button className="btn btn-secondary" onClick={() => uploadQr2('wechat')} style={{padding:'4px 10px',fontSize:'0.8rem',marginTop:4}}>{t.upload}</button>
          {qrMsgs.wechat && <p style={{fontSize:'0.8rem',color:'#4ade80',marginTop:2}}>{qrMsgs.wechat}</p>}
        </div>
      </div>
    </div>
  );
}
